




















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Caretaker, Pricing } from '@/models'
import { confirmPricingOverlaps } from '@/utils/pricing-overlap-confirm'

const LABELS: Record<string, string> = { card_issuance: 'Émission', card_loading: 'Chargement' }

@Component({ name: 'CaretakerCardPricing' })
export default class extends Vue {
  @Prop({ required: true }) caretaker!: Caretaker

  negotiatedPricings: Pricing[] = []
  defaultPricings: Pricing[] = []
  loading = false

  dialogVisible = false
  dialogPricingItem = ''
  dialogValue = ''
  dialogValidFrom: Date | null = null
  dialogValidTo: Date | null = null
  dialogLoading = false

  get items() {
    return Object.keys(LABELS).map(pricingItem => ({
      pricingItem,
      label: LABELS[pricingItem],
      negotiated: this.negotiatedPricings.find(p => p.pricingItem === pricingItem && this.isCurrent(p)),
      default: this.defaultPricings.find(p => p.pricingItem === pricingItem && this.isCurrent(p))
    }))
  }

  get history() {
    return [...this.negotiatedPricings].sort((a, b) => b.validFrom.localeCompare(a.validFrom))
  }

  get defaultSummary() {
    return Object.keys(LABELS)
      .map(pricingItem => {
        const pricing = this.defaultPricings.find(p => p.pricingItem === pricingItem && this.isCurrent(p))
        return `${this.labelFor(pricingItem)} ${pricing ? this.formatValue(pricing) : '—'}`
      })
      .join(' · ')
  }

  created() {
    this.load()
  }

  isCurrent(pricing: Pricing) {
    const now = new Date()
    const from = new Date(pricing.validFrom)
    const to = pricing.validTo ? new Date(pricing.validTo) : null

    return from <= now && (!to || to > now)
  }

  labelFor(pricingItem: string) {
    return LABELS[pricingItem] || pricingItem
  }

  formatValue(pricing: Pricing) {
    return pricing.unit === 'percentage'
      ? this.$n(pricing.value, { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 2 })
      : this.$n(pricing.value, 'currency')
  }

  async load() {
    this.loading = true
    const [negotiated, defaults] = await Promise.all([
      Pricing.where({ caretakerId: this.caretaker.id }).per(100).all(),
      Pricing.where({ default: true }).per(100).all()
    ])
    this.negotiatedPricings = negotiated.data
    this.defaultPricings = defaults.data
    this.loading = false
  }

  openDialog(pricingItem: string) {
    this.dialogPricingItem = pricingItem
    this.dialogValue = ''
    this.dialogValidFrom = null
    this.dialogValidTo = null
    this.dialogVisible = true
  }

  async submit() {
    const value = this.dialogPricingItem === 'card_loading' ? Number(this.dialogValue) / 100 : Number(this.dialogValue)
    const validFrom = this.dialogValidFrom ? this.dialogValidFrom.toISOString() : undefined
    const validTo = this.dialogValidTo ? this.dialogValidTo.toISOString() : undefined

    this.dialogLoading = true
    try {
      const confirmed = await confirmPricingOverlaps({
        pricingItem: this.dialogPricingItem,
        caretakerId: this.caretaker.id,
        value,
        validFrom,
        validTo
      })
      if (!confirmed) return

      const pricing = new Pricing({
        pricingItem: this.dialogPricingItem,
        caretakerId: this.caretaker.id,
        value,
        validFrom,
        validTo
      })

      await pricing.save()

      this.$notify({ title: 'Succès', message: 'Tarif négocié enregistré', type: 'success', duration: 2000 })
      this.dialogVisible = false
      this.load()
    } catch (err: any) {
      const errors = err?.response?.data?.errors
      this.$notify({
        title: 'Erreur',
        message: errors?.length ? errors[0].detail : 'Enregistrement impossible',
        type: 'error',
        duration: 3000
      })
    } finally {
      this.dialogLoading = false
    }
  }
}
